import React from 'react';
import { TextField } from '@mui/material';
import { useReportingEditor } from '../../../../hooks/useReportingEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const ReportTitleEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useReportingEditor(mode);

  return (
    <TextField
      size="small"
      fullWidth
      required
      label="Title"
      value={request?.title || ''}
      onChange={(e) => updateRequest({ title: e.target.value })}
    />
  );
};

export default ReportTitleEditor;
